import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitOfferings = createSelector(
  [selectFinancialCockpitState],
  ({ offerings }) => offerings
)
